/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var DOCUMENT_POSITION_CONTAINED_BY = 16;
var _default = contains;
exports.default = _default;
function contains(container, elem) {
  if (container.contains) {
    return container.contains(elem);
  }
  var comparison = container.compareDocumentPosition(elem);
  return comparison === 0 || comparison & DOCUMENT_POSITION_CONTAINED_BY;
}


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/contains/index.js
// module id = 157
// module chunks = 0